export default "__VITE_ASSET__BZYMpiCh__"